import React from 'react';
import PageHeaderBase from './PageHeader';

function PageHeader(props) {
  return <PageHeaderBase {...props} />;
}

export default PageHeader;
